module.exports = __webpack_public_path__ + "img/nfc-success.b9ab4aac.svg";